export default __webpack_public_path__ + "static/media/pictogramBeaconCelebration40.90328635.svg";